var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mdb-container',{staticStyle:{"width":"420px"},attrs:{"id":"advertisementPreview"}},[_c('mdb-btn',{attrs:{"data-html2canvas-ignore":"true","color":"primary","size":"sm"},on:{"click":_vm.windowPrint}},[_vm._v(_vm._s(_vm.$t("advertisement_preview_save")))]),_c('CouponPreview')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }